import { useTranslation } from 'react-i18next';
import Styles from '../GroupInfoModal.module.css';

const ControlButtons = ({ addUser, onBack, searchResults, adminControl, addPartcipiants, loading, setLeaveConfirmModal }) => {
  const { t } = useTranslation();
  return (
    <div className={Styles.paricipantsContainer} style={{ padding: '12px 20px 8px' }}>
      {!addUser ? (
        <span className={Styles.participants_tag}>{t('screens.chat.participants')}</span>
      ) : (
        <div style={{ display: 'flex', cursor: 'pointer', alignItems: 'center' }} onClick={onBack}>
          <div className={Styles.participants_tag1}>{t('screens.chat.back')}</div>
        </div>
      )}
      {searchResults &&
        searchResults.length > 0 &&
        adminControl &&
        (addUser ? (
          <span className={Styles.participants_tagnew}>{t('screens.chat.availableUsers')}</span>
        ) : (
          <span className={Styles.participants_tag1} onClick={addPartcipiants}>
            {t('screens.chat.addParticipants')}
          </span>
        ))}
      {!loading && searchResults && searchResults.length > 0 && !adminControl && (
        <div className={Styles.leaveGroup} onClick={() => setLeaveConfirmModal(true)}>
          <span className={Styles.participants_tag3}>{t('screens.chat.exitGroup')}</span>
        </div>
      )}
    </div>
  );
};

export default ControlButtons;
